<template>
  <div>
    <div class="error-wrap" v-if="endOfService && isInitCompleted">
      <div class="error-inner">
        <h1><img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJYAAAAzCAYAAAB10PG/AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMDY3IDc5LjE1Nzc0NywgMjAxNS8wMy8zMC0yMzo0MDo0MiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTUgKFdpbmRvd3MpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOjIzM0E2NzMxNjIzMDExRThCMjUwQTUxNkE1MTUwRjZDIiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOjIzM0E2NzMyNjIzMDExRThCMjUwQTUxNkE1MTUwRjZDIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6MjMzQTY3MkY2MjMwMTFFOEIyNTBBNTE2QTUxNTBGNkMiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6MjMzQTY3MzA2MjMwMTFFOEIyNTBBNTE2QTUxNTBGNkMiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz7p6iK+AAAO0ElEQVR42uxcCXQURRqu7jkzM7nviwgYErmGQwiHHKIorrh4oOA1gvvWJ09xhaeIru+57q7gwVt31V1XV0WiLj5WARWFRRIQkRskiEi4w5WE3HNkMpOZ7v0r02Fh6Kqunhl2E+n/verMdNXfXfXXV/9VNeFQNGR3PAjXdxVa/RJVlH6BNLqsiI+S/zaGNndpYr78iItCW9ngWgfFrNDSCSUDtJZPE7emsVhoEgOoMCVAuU4TtQasWJrBTrpDE7VmClnMoEEyg4mMHE1QMsEctmsi1zQWja5VASpMyZo51IAVazOomUPNFDKZQQzGU1CyZWqPQMHRX1+ZuroOnorSYCw6/uwbnxS2+duLdTzfYDYZdj8/6/Y2Fr6nX1tWLIoozmTUVwJPa7ebMbvDBNceUFKg1II8j/9cgDUCrlsItThZ6oXyKKH+ehBEmVzF/L8sG7r/6Ol35OoKstMWvz7//teee3N50sGqmg+37zt6/ZGTZ02d9fFWszisX6+TQ64qeGzR3Ls/C+d/ZEHpUxUHTzz+/YGqLI83lPXgeQ4NLMx32vv0+PKK3LSHAGRuaXzz4Zol040A9P0JgkyMcH1ZpkaA8gTwCQSAvESQ0xHgeT2sPY7CZ0suhSlsMS+E9u9K7RbBNU3mmVUU9+Uw8L9BmfNhcL2XUPsv4P0uFsB6Ea5PEWrvh4InaAWh/i3oxMNyFXMX/XPanz5Y87Fc3X03j1qZl5my4NN1OzYeOlFLTHEYDXrkuGX039957lez8HcAYtq3uw/uKt++vwdtSIU9Mn23Tbj6ppfnTFsP4yuVxiFHRdD/gzIyKYHrVgLPQOD5QYZnJFw3E3heBZ65Ujvsny6GMkVhZpZAmQnlGF6LMvXvQ5lBCa7SZBdAqA940TxJ4B0EfBWx8LFo/tUGKOullSrPGzKlqigoCEYlUGHytwfQeys3PjznlY9mAqhsqzftrVQCFSZ4rql01aavsdaEr+WUpsMJ90dReEh1JRSecmlC8+C6jQFUmB6AMo9Sf0JyR0jB1cAIxnBaDlTqgWV3YN+pD0V9n4LSAp93EdpkQBmtFlhg+q5TAtU52yOIaMPOA3/+8cjp1cCXwvqOmvoW3Xd7Dq2Cj+siEPBICs9IlfeDHQvU7sDjxWa9UIWofgcliVAnQvmcwnsNJbU0lMCzJlZRoZK26qQySjvVe4fn+1MsBL5UwoqyXdeofc+3uyuz5s24uQg+HiQ0GUG4PzqGwNoKi9MtgWSIyiGYFdJAn1DqxhPuD0bkHZYvYwWsWyl1GxmBdUck5jAC8xkRX01D80OU/g+EvlvCVjQ2tTmUR/aBNqlhPDiizieawdAz5yp0tRbKDihqIlvspjgJdWNULqZ2mnZnn2C7AwviakZgfSelHeQoW8F0EAlHf9eV9D0+afSAyuy0JOa0Rb/euZ7JYwftnTC87wmL2Uht29Ds7kfxs3QyMhjF0IUSFaazXIqqDYR6lxRc5IBmGy7J830mQYQOAnxBdFPsjmIVmnUTPM8VC41F01ZVF+RTKkq9lIgH0+1qQTW4uMD5m3tuKCp7e37PNX97svihqeNTxg4tOqPEN3PKmCU/Ll9oW/X6XHv5P+YXzL574rjM1EQiKJtdrWnS5IqMJowFWKMYtYBXSuXcR/GTpoB8PzwXwVWUYg30IM0shdEKSt04FcCivi9WwNpAjGzk6U5YHcypDh3Po4kj+t/4x0enHuq89/ys251jBheNssaR3a/RgwprF//+1xeE2C89Pm3jL64ZuITE4/W1m2CyGrGrxggsFu07ghGMm1AouZxNqF8KfVsvo4lESjognL6C0sZkDkMmu4DynCiBZXekENBMAxYtuspXCLcvNGVX5rpenjPtojzRC7OnVtn79Kgj56ey1srdz81IfpHhteWKZi3kbw0Oq8d5pOqLeOwOncSjpzjl6xTk8hbFzP0E1z0M5tBLAcV4xkVTJb0vao11i+RfqAHWToqjGHLiGSkrNbGGVJeSaK0m1dkspr1y97HmA00na+o8Xp9JIQDJAnBcIX2+WkYuW2XcAHwocoD0eRCUOAqY+xPqWiXflUZbGEW6knA/97yx0Uy2otllBRa7f/XflREIc+gj9rMsZlMTqc5o0HsodURAJtrilMLGjVLkQzOHcmmGzUg+Cz9SYbLwGHdTosXDDPusVYwi/ZwytvEMJnu10gv0DGYQr65JlBYJ0GYDoa4Xha8X8A0FYe1S6oJBr/NS/C8/hZV4/ovjOFHBZLRC/7AGGEswh0sJpmIrIaLDbd+kAGtDh0NudyRSgKdEzYzRYQu8B2vHG2Vqr+mIMsmJUZ+C/8wILOUjyMkK/heiOvHkLH3UpNfpGqN8RDkBWCMJK9or+TnYPGLAG2XMCglYnaY3Xu0iCZt0VvqUAKxOjUVKjG7oWHQxMIW3oUtHl/SMFschb5SPIPlZg2FF47211Iv8SuwChPJFu8NjCWlLrLfCu0gRWxJDf5NVjA1vF8m5A72laHBEJNEgG7BCEczkSzj3V8I7BqCuS3gDWM6Hw2biEQXnWc6RfozwHryZe0D67Ca0SWfobw/mkVWUnqUEA+MoEWEMgBV6QfIlnryu+7vD0Bn9bwi1DgVgySWIZzCkNkhJ3wLpCA2NBqsc4ScqgXUIZHI4FsC69X8wfXeirk0kR9UcAbBMDO+g5YemUKwLPjkyRuXYVlLeUxCptqIDK5QZpwErKK1mllJHeU4RvKtfFwZWGWO7Y7Caa8/TdljznGTkPT+ZvJ3Sbo7knsjRU0jtoYKKUnxGa4dMTXakaQaWqBAn//Ko/kdF6Ximt9gdz8D1BUoLnNM62EWBhZOs9Uj+uG94miGcsA8zXYHvYMc5tgu1nhOFfugbTjhgeAnk+YS0jdMpXxxgPR7h+JZDGcbQrhXJJ8JVm0IlM/hvFZ1f0439LBw5rWdouVnBNLJpxFBEuYzSHh+n+RrANBPKdCgfS+CI9CjSCmbNreLfJPBRpBnUAAtv6NZS6vsfOFad083N4TZGLcbiw72KyMe7MeEfVLyHQknaaVEunEq47mNouVrNY3mC6cKnKK+i8DWi0F4ga+dFJSDuO3KqpBsDC+ee5DaAcS6LlksTZYFVUbof0TacY08rGdp8GT2wlLXVugh+H0g1h3WNruFd2BziEPsEpcUu2X8fENov3UnV5KEjOnI0j1GTnE/VEY7wM4X6HyVHP2pgxdK/6qS1NPXu9fl7dvG0Q5lK/4rFzyqngBknSm+Csp+xf/4ofFXsqvii8JEZgGV3YF9nOANI1K76BkJo212oXGVEyAK6MgWZ4WhxhGQWaRYCpzVugPabItTIQQmYJFql9pFy6QaM3AkUnkBYeKyGHiDlSHLSk5IHFReU9M7LuOioi8VsJJqTXnnpz86+e6LsWXyzyUA0JXdOHD4rKAi28Pv4J/uVnxH9kGsJj9tJdRvIfFsYJh2fK39Y+qHwdAloWIbY9FZJi3yZdIAPUd51nJIOwoqEtPndgpTPgV1EHNLo8qbQhjNOOZCCJ3wc+p5YaCyNgDyvfKRHgWAuCgppSBBTxGAwBb5nwPd4JOAimsVAMB6JIgf3O34YK7YH8H1VMuUMOhfi+UDHF4O+QbrXiHQ6J6jPJqTX1XM63Vn42wBqoMH6tON0lECaikK/AsJHevCJiSJETzstjeQ1+ssAIEnI114Ik14Ef/NReyBH9PkzRa8/G7X5k8U2n01s81sgejCLrW1G0dOmF91enXfR0i45nvrMyYizmEVkNop8grWdi4/zcVaLG1lMTi7O1MSZDPVQd4YzGqqR0XASvlcgk+EH65P3dvpQeDeF9fxcTSSOe7c2hQCYBOT1DwVQDABwFKPWtgLR68sEUKSLztZ40emxCo1OA/yNzRh5DnE2i8hZzUGY2ABMoh8m0MeZjF5k0LXDRLpBw/iRXt/aoYVCn5sk3nZOrwud7uS4NtBGLdR3CYKlQyt2JrsCwUTQhEYUBA0ZFEyiP5AE9SbQlGbR326BBWIFOcTBwjB1LA5YGFB4WETn+s6nJga5tCTvaxwKPtfoZP2neb8FM7jgZ6WxPAtLc0FYo0CTDAEh9QWAFABgMoRmV4JY3xIHGiWqX1NzKQmCzIpvllZ8DQDlNKz4U5xBX4WM+sPW+fcf63aLD2SI/IF+oK17Ip+/t9jWnuc+cgofN1YEVopB795y7ZD6vPtuTANtV9+tNJbnhSXFoGUmiK7WoVD6ik2uXKGhJUWobbKIza6I+gYaReTTktq55Hg3F29xQqmBe2c4s+kYAKYSAPMDijPuA2G5L1NnHW9Wv0prkqrXBVamJbn6NbTYhJpGA5+eFODz0htArsf4lIQdXKLtC5DhepBh4P8GLDBZFjBTE0WXd5zQ4raLze6eQl1zhnC6zhKJmeISrSKfkdIGA2zikm3VAJyjnDXuJ9A234OG2WZ9xlGNNIoEWFgr4WQs3hN8u3NHAObPDC7HaNHder3Q5CoR65oLhTP1GdjN0F2R5eRz0w/x6cnfcEm2j6zPzvg+5sC6AEDN7iFifXNvoaYhPYj/U0xA3e4Pn5US5DNTnbBSzgCQDnO2uJ9QnGkPZzZuhqjopIaOqICll0wh9uGw1g505KrOP4bDGBSBizJZbHRNEuqahgnHqwvA9+N1hXnHAWxlEQHL8+IHhWKLZ4rY4h4D2qc/aJ+cYFWNWQ2AsObR5WW4ufSks6Baj/GJ1j3IYt4OICoDFduoIaAbBlQLSrPBpZkO2q1EEVie3y8eIbo8d4DqGwm+T6FQVZMqnG3SqQJQj0wnl558mk9NOMAl2DYDeL4Gk7VXm4qfL3FhiBsITvNdQoNzrFDbWBw8dCoVvrNFXwY9AgB5+fyMMxDa7gMttAn8n7UagC5jYDkdf9gV2F1pB7PGpIlA44i6wvwmPjP5KITtu/hE2zpkNX8FJqxVE6lGHRjxLCzN9/51+YlzybTwBnEmpOuV4+LzMg5xaYnb+KT4FRBqYj9I0MSnEYn0Yn3LvHOgwuasV45Hl595HEC0nU+OXwWaaNV52wEaacQGLMHnzzLdOnYtAGlVRy5Ci8g0igH9R4ABAHWURTl70C/BAAAAAElFTkSuQmCC" class="" alt="Amway"></h1>
        <p class="error-tit" v-html="messages.SERVICE_CLOSE_MESSAGE"/>
        <p class="error-text"></p>
      </div>
    </div>

    <div id="skipToContent">
      <a href="#contents">콘텐츠 바로가기 </a>
    </div>

    <!-- main -->
    <main class="dashBoard_promotion v2" v-if="!endOfService && isInitCompleted">
      <!-- //header -->
      <div id="dashBoardHeader" class="dashboard-header">
        <div class="dashboard-header__inner">
          <!-- S : 20230315 대시보드 업데이트 -->
          <div class="dashboard-header__user">
            <span class="user-name">{{aboName}}</span>
            <span class="user-num">({{aboNo}})</span>
          </div>
          <h1 class="dashboard-header__title">
            <template v-for="(message, index) in this.messages.TITLE" >
              <br class="mo" :key="index" v-if="index > 0"/>{{message}}
            </template>
          </h1>
          <a :href="amwayLink" class="dashboard-header__link">
            <span class="logo"><span class="hidden">Amway</span></span>홈으로 >
          </a>
        </div>
      </div>
      <!-- //header -->
      
      <!-- contents -->
      <div class="abo-dashboard">
        <div class="main-dash_section">
          <div class="chart-section-box">
            <DashboardContentsAttainment
              @layer="showing.members = true"
              :data="getObjectiveData"/>

            <DashboardContentsAttainment
              @layer="showing.sop = true"
              :data="getSopData"
              />
          </div>

          <DashboardContentsAbocardList
            :abocardlist="aboCardList"
            :eos="eos"
            :link="messages.HYBRIS_NOTICE_LINK"
            />
        </div>

        <!-- 목표 달성시 style="display: block;" 추가 -->
        <div class="abo-dimmed" v-show="showEffect" style="display:block;">
          <div class="dimmed-text" v-html="congratsMessage" />
        </div>
      </div>
    </main>
    <!-- //main -->

    <div id="aboPromotion1" class="layer_section layer-area type-wide-a abo_promotion abo_sep_promotion showing" v-show="showing.members">
      <Transition name="slideup" >
        <DashboardLayerAttainment @layer="closeLayer" v-show="showing.members"/>
      </Transition>
    </div>
    <div id="aboPromotion2" class="layer_section layer-area type-wide-a abo_promotion abo_sep_promotion showing" v-show="showing.sop">
      <Transition name="slideup">
        <DashboardLayerAttainmentBasket @layer="closeLayer" v-show="showing.sop"/>
      </Transition>
    </div>
    

  </div>
</template>

<script>
// Component
import DashboardContentsAttainment from './component/attainment.vue' // 달성정보-그래프(메인)
import DashboardContentsAbocardList from './component/abocardList.vue' // 구성원-목록
import DashboardLayerAttainment from './component/layerAttainment.vue' // layer-달성조건보기layer
import DashboardLayerAttainmentBasket from './component/layerAttainmentBasket.vue' // layer-달성조건보기layer

// Library
import Vue from 'vue'
import axios from 'axios'
import VueConfetti from 'vue-confetti'
import { mapGetters } from 'vuex'
import { 
  SALES_DASHBOARD,
  FETCH_ATTAINMENT_INFO, 
  FETCH_EFFECT_SAVE,
  SET_ABO_INFO,
  SET_SHOW_EFFECT_FLAG,  
  GET_ABO_INFO,
  GET_ATTAINMENT, 
  GET_EOS,
  GET_ABO_CARD_LIST,
  GET_INIT_COMPLETED,
  GET_EFFECT_FLAG,
  GET_SHOW_EFFECT_FLAG,
  GET_MESSAGES,
} from '@/store/actions/dashboard'

Vue.use(VueConfetti)

export default {
  name: 'salesDashboard',
  data() {
    return  {
      showing: {
        members: false // 목표달성 Layer 활성 여부 
        , sop : false // SOP 달성 Layer 활성 여부 
      }
    }
  },
  components: {
    DashboardContentsAttainment,
    DashboardContentsAbocardList,
    DashboardLayerAttainment,
    DashboardLayerAttainmentBasket,
  },
  computed: {
    ...mapGetters(SALES_DASHBOARD, {
      aboInfo : GET_ABO_INFO,
      attainment: GET_ATTAINMENT,
      aboCardList: GET_ABO_CARD_LIST,
      eos: GET_EOS,
      initComple: GET_INIT_COMPLETED,
      effect_flag: GET_EFFECT_FLAG,
      showEffect: GET_SHOW_EFFECT_FLAG,
      messages: GET_MESSAGES,
    }),
    aboName() { 
      return this.aboInfo.aboName || '';
    },
    aboNo() { 
      return this.aboInfo.aboNo || ''; 
    },
    congratsMessage () { 
      return this.messages.CONGRATS;
    },
    amwayLink() { 
      return process.env.AMWAY_ROOT_URL;
    },
    endOfService() { 
      return this.eos; 
    },
    getObjectiveData() {
      return this.attainment.objective;
    },
    getSopData() { 
      return this.attainment.sop;
    },
    isInitCompleted() { 
      return this.initComple;
    },
  },
  methods: {
    init: async function () { // 초기화
      await this.checkLogin() // 로그인 체크(회원번호,이름)
      await this.reset() // 항목 초기화 

    },
    // 로그인 체크
    checkLogin: async function () {
      await axios.get(process.env.OCC_ROOT_URL + '/sso/authorizeEvent', {withCredentials: true}
      ).then(response => {
        if (response.data.header.status === 'ERROR') { // login fail
          window.location.href = process.env.AMWAY_ROOT_URL + '/login'
        } else if (response.data.customerUid != null && response.data.customerUid !== 'none') {
          // login success
          this.$store.commit(`${SALES_DASHBOARD}/${SET_ABO_INFO}`, {
            aboNo : atob(response.data.customerUid)
            , aboName : response.data.name
          })
        }
      }).catch(ex => {
        window.location.href = process.env.AMWAY_ROOT_URL + '/login'
      })
    },
    // 레이어 닫기
    closeLayer: function () { 
      this.showing = { 
        sop : false, 
        members : false
      }
    },
    // 항목 초기화 및 회원정보 조회 
    reset: async function () {
      // api 조회
      await this.$store.dispatch(`${SALES_DASHBOARD}/${FETCH_ATTAINMENT_INFO}`, {year: '2023', month: '09'})       
      await this.attainmentEffect() // 목표달성 효과
    },
    // effect 여부 처리 (effect 실행 기록 저장 호출)
    attainmentEffect: async function () {
      // 목표달성 여부 체크      
      if ( this.effect_flag) {
        this.$store.commit(`${SALES_DASHBOARD}/${SET_SHOW_EFFECT_FLAG}`, true);
       
        // effect 종이날리기 효과 시작 
        this.$confetti.start({
          particles: [{type: 'rect'}],
          defaultColors: ['DodgerBlue', 'OliveDrab', 'Gold', 'pink', 'SlateBlue', 'lightblue', 'Violet', 'PaleGreen', 'SteelBlue', 'SandyBrown', 'Chocolate', 'Crimson']
        })

        await this.$store.dispatch(`${SALES_DASHBOARD}/${FETCH_EFFECT_SAVE}`);
        
        // effect 종이날리기 효과 중지 (3초 지속)
        setTimeout(() => {                      
          this.$confetti.stop() 
          this.$confetti.remove()
          this.$store.commit(`${SALES_DASHBOARD}/${SET_SHOW_EFFECT_FLAG}`, false);
        }, 3000)
      }
    },
  },
  mounted: function () {
    window.setTimeout(() => {
      this.init()
    }, 500)
  },
}
</script>

<style scoped>
@import './assest/css/abo.css';

.slideup-enter-active {
  animation: slideup 0.5s ease-in-out;
  transition-delay: 0.25s;
}
.slideup-leave-active {
  animation: slideup 0.5s ease-out-in reverse;
}
@keyframes slideup {
  0% {
    opacity: 0;
    transform: translateX(-50%);
  }
  50% {
    opacity: 0.1;
  }
  100% {
    opacity: 1;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/sales/dashboard3/dashboard.vue